import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {Container} from 'reactstrap';
import Graph from './dashboard_graph';
import Overview from './dashboard_overview';
import { connect } from 'react-redux';
import {
  fetchGroupList,
  fetchFacilityList
} from 'shared/actions/actions';

import moment from 'moment';



class Dashboard extends Component {
  constructor(props) {
    super(props)
    this.state={
      start_date:moment()
    }
  }

  componentDidMount() {
    // Groups will be fetched by the Overview component
  }

  render() {
     const { group_data,facility_data,dispatch } = this.props
    const data = [
                  {name: 'Page A', uv: 4000, pv: 2400, amt: 2400},
                  {name: 'Page B', uv: 3000, pv: 1398, amt: 2210},
                  {name: 'Page C', uv: 2000, pv: 9800, amt: 2290},
                  {name: 'Page D', uv: 2780, pv: 3908, amt: 2000},
                  {name: 'Page E', uv: 1890, pv: 4800, amt: 2181},
                  {name: 'Page F', uv: 2390, pv: 3800, amt: 2500},
                  {name: 'Page G', uv: 3490, pv: 4300, amt: 2100},
                ];
    return (
      <Container fluid={true}>
        <div className="pm-page-card">
        <Overview />
        {/* <Graph graph_data={data}/> */}
        </div>
     </Container>
    )
  }
}

Dashboard.propTypes = {
  
}

function mapStateToProps(state) {
  const {postsBySubreddit } = state
  const {
    group_items: group_data,
    facility_data:facility_data

  } =  postsBySubreddit

  return {
    group_data,
    facility_data
  }
}

const AppContainer = connect(  
   mapStateToProps
)(Dashboard);

export default AppContainer;



// WEBPACK FOOTER //
// ./src/shared/containers/Dashboard/index.js